export const gdpr = {
  routes: [
    {
      path: "/datasource-data/:datasource",
      component: () => import("../organization-datasource-data-view"),
    },
  ],
};
